<div *ngIf="asignaturas">
    <instrumento-mensual-asignatura
        *ngFor="let asignatura of asignaturas"
        [tipoInstrumento]="tipoInstrumento"
        [asignatura]="asignatura"
        [month]="month"
        [year]="year"
    ></instrumento-mensual-asignatura>
</div>
